
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facility-application",
      function () {
        return require("private-next-pages/facility-application.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facility-application"])
      });
    }
  